window.addEventListener("load", function () {
  const STORAGE_KEY = "lan_popup_letter_closed";
  const popupLetter = $("#popup_letter");
  const popupSelect = $("#popup_select");

  // Handle character selection in select popup.
  if (popupSelect.length > 0) {
    const selectForm = popupSelect.find("form").first();
    const selectItems = selectForm.find(".group__select--item");
    const submitButton = selectForm.find(".btn__select");

    const updateSubmitState = function () {
      submitButton.prop("disabled", selectItems.filter(".active").length === 0);
    };

    selectItems.on("click", function (e) {
      e.preventDefault();
      selectItems.removeClass("active");
      $(this).addClass("active");
      updateSubmitState();
    });

    selectForm.on("submit", function (e) {
      if (selectItems.filter(".active").length === 0) {
        e.preventDefault();
        return;
      }

      e.preventDefault();
      popupSelect.removeClass("active");
    });

    updateSubmitState();
  }

  if (popupLetter.length === 0) {
    return;
  }

  const hidePopupLetter = function () {
    popupLetter.removeClass("active").hide();
  };

  try {
    if (window.localStorage.getItem(STORAGE_KEY) === "1") {
      popupLetter.removeClass("active").hide();
      return;
    }
  } catch (error) {
    // Ignore storage errors (private mode / blocked storage)
  }

  const letter = popupLetter.find(".letter");
  if (popupLetter.hasClass("active")) {
    const letterNormal = letter.find(".letter__normal");
    const letterCenter = letter.find(".letter__center");
    const letterDone = letter.find(".letter__done");
    const letterButton = letter.find(".btn__letter");
    const closeLetter = popupLetter.find(".btn-close");
    const arrow = popupLetter.find(".arrow");
    const OPEN_DURATION = 900;
    let isAnimating = false;

    const closePopupLetter = function () {
      try {
        window.localStorage.setItem(STORAGE_KEY, "1");
      } catch (error) {
        // Ignore storage errors and continue closing popup
      }
      hidePopupLetter();
    };

    letterNormal.on("click", function () {
      if (isAnimating || letterNormal.hasClass("close")) {
        return;
      }

      isAnimating = true;
      letterNormal.addClass("is-animating");
      letter.addClass("opening");
      arrow.fadeOut(200);
      letterDone.removeClass("open");
      letterCenter.removeClass("out").addClass("open");

      setTimeout(function () {
        letterCenter.removeClass("open").addClass("out");
        letterNormal.addClass("close").removeClass("is-animating");
        letterDone.addClass("open");
        isAnimating = false;
      }, OPEN_DURATION);
    });

    letterButton.on("click", function (e) {
      e.preventDefault();
      closePopupLetter();
    });

    closeLetter.on("click", function () {
      closePopupLetter();
    });
  }
});
